export enum LivenessError {
  USER_CANCELLED = 'user_cancelled',
  FACE_DETECTION_TIMEOUT = 'face_detection_timeout',
  HEAD_TURN_TIMEOUT = 'head_turn_timeout',
  CAMERA_NOT_AVAILABLE = 'camera_not_available',
  CAMERA_NOT_FOUND = 'camera_not_found',
  PERMISSIONS_ERROR = 'permissions_error',
  RECORDING_ERROR = 'recording_error',
  UNKNOWN_ERROR = 'unknown_error',
}
